import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-50d6d5cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "resetAllFilter row" };
const _hoisted_2 = { class: "col-12 pt-4 pb-4 border-top" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/icons/clear.svg",
    alt: "x",
    class: "mr-1",
    height: "16",
    width: "16"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "strong d-inline-block" }, "Alle Filter löschen", -1));
const _hoisted_5 = [
    _hoisted_3,
    _hoisted_4
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.resetAllFilters && _ctx.resetAllFilters(...args))),
                class: "resetFiltersButton font7 p-2 text-center d-flex justify-content-center align-items-center border rounded",
                style: { "cursor": "pointer", "height": "48px" }
            }, _hoisted_5)
        ])
    ]));
}
